import api from './utilBackoffice';

const controller = 'Informacao4111';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Create: dto => api.Axios.Post(url + '/create-informacao', dto),
  Update: dto => api.Axios.PutCommand(url + '/update-informacao', dto),
  Delete: dto => api.Axios.DeleteCommand(url + '/delete-informacao', dto),
  GetAllPaged: dto => api.Axios.GetParams(url + '/grid-informacao', dto)
});
